import { apiClient } from '~/lib/api/client';

export type Cn01FormStatusItem = {
  refNo: string;
  permitNo: string | null;
  status: string;
  createdAt: string;
};

export type Cn01FormsStatusResponse = {
  planterId: string;
  items: Cn01FormStatusItem[];
};

export async function getCn01FormsStatus(): Promise<Cn01FormsStatusResponse> {
  const res = await apiClient.get<Cn01FormsStatusResponse>('/cn01/forms/status');
  return res.data;
}
